<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para1"><a id="page_ii"></a><em>Also by Kelli Stanley</em></p>
<p class="image"><img alt="Image" src="images/star.jpg"/></p>
<p class="center-para"><em>Nox Dormienda</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?af10f124